'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/scheduler-tracing.production.min.js');
} else {
  module.exports = require('./cjs/scheduler-tracing.development.js');
}



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/scheduler/tracing.js